import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetPagedSyncEntitiesRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetPagedSyncEntitiesResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getPagedSyncEntities = (request: GetPagedSyncEntitiesRequest, options?: CashRequestOptions) =>
  post<GetPagedSyncEntitiesRequest, GetPagedSyncEntitiesResponse>('/2.0/cash/get-paged-sync-entities', request, {
    ...options,
    rejectOnError: true,
  })
